import {User} from '@blesk-frontend/api';

/**
 *
 * @param user
 */
export const getUserAvatar = (user: User) => {
  return user.avatar?.file.src || null;
};
